import { Component, Inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { UpdateBlobDocumentModel } from 'lemunzo-api';
import { FileUploadModalData } from '../../models/file-upload-dialog-data';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

@Component({
    selector: 'apcam-file-upload-confirmation',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss'],
    imports: [
        FileUploadComponent,
        MatButtonModule,
        MatIconModule,
        SharedDialogShellComponent,
    ],
})
export class FileUploadDialogComponent {
    protected get dialogShellConfig(): SharedDialogShellConfig<void> {
        return {
            title: this.translateService.instant(
                'shared.fileUploadDialog.uploadNewFile'
            ),
            cancelLabel: this.translateService.instant('shared.buttons.cancel'),
            cancelIcon: 'close',
            showConfirmButton: false,
        };
    }

    /**
     * URL of the upload worker, provided by the app using this library component.
     */
    protected readonly uploadWorkerUrl = input.required<string>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FileUploadModalData,
        private readonly dialogRef: MatDialogRef<FileUploadDialogComponent>,
        private readonly translateService: TranslateService
    ) {}

    protected localFilesEvent(data: UpdateBlobDocumentModel[]): void {
        this.dialogRef.close(data);
    }
}
